import Input from '../Input/Input.theme';
var TextArea = Input;
export default TextArea;